const YoutubePage = () => {
  return (
    <div>
      <iframe
        width="100%"
        height=""
        className="h-[500px] border-t-[10px] border-x-[10px] md:rounded-t-[30px] rounded-t-lg"
        src="https://www.youtube.com/embed/ykfo8QGKAto"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default YoutubePage;
